import React, { memo, useCallback, useState } from 'react';
import { PlusIcon } from '@icons/icons/PlusIcon';
import { themeColors } from '@styles/theme';
import DistrictImportModal from '@features/districts/districts-import/ui/DistrictImportModal';
import { useTheme } from '@context/themeContext';
import { useTranslation } from 'react-i18next';
import Button from '@components/buttons/Button';
import { useEntitiesLoader } from '@features/entities/entities-list/model/useEntitiesLoader';

const DistrictImport = memo((props: Pick<ReturnType<typeof useEntitiesLoader>, 'loadData'>) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { theme } = useTheme();
    const { t } = useTranslation();

    const btnClick = useCallback(() => {
        setShowModal(true);
    }, []);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Button
                img={
                    <PlusIcon
                        color={theme === 'light' ? themeColors.bluePurple : themeColors.white}
                    />
                }
                text={t('road-network.districts-import-btn')}
                colorType="transparent"
                onClick={btnClick}
            />
            {showModal ? <DistrictImportModal setModalShow={setShowModal} {...props} /> : null}
        </div>
    );
});

export default DistrictImport;
